import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=a5fe046c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=a5fe046c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fe046c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5fe046c')) {
      api.createRecord('a5fe046c', component.options)
    } else {
      api.reload('a5fe046c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=a5fe046c&scoped=true&", function () {
      api.rerender('a5fe046c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Xda6ljlxhAjN/JS/comp/PopupBox.vue"
export default component.exports